<div class="w-[108px] mr-5">
  <label
    class="input-main-label block mt-0 mb-1"
    for="operator"
  >
    Operator
  </label>

  <mat-form-field
    class="select-classic has-validation w-full"
    appearance="outline"
  >
    <mat-select
      id="operator"
      (blur)="onTouched()"
      (ngModelChange)="onValueChange($event)"
      [disabled]="isDisabled()"
      [errorStateMatcher]="errorMatcher"
      [ngModel]="value()"
      panelClass="single-select-overlay"
      placeholder="Select"
    >
      <mat-select-trigger>
        @if (value()) {
          <avs-incident-rule-operator [operator]="value()!" />
        }
      </mat-select-trigger>

      @for (operator of operators; track operator) {
        <mat-option [value]="operator">
          <avs-incident-rule-operator [operator]="operator" />
        </mat-option>
      }
    </mat-select>

    <mat-icon
      class="arrow-down"
      fontIcon="keyboard_arrow_down"
      matSuffix
    />

    <mat-error>Input is not valid</mat-error>
  </mat-form-field>
</div>
